import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// 重复问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export const constantRoutes = [];
const createRouter = () =>
  new Router({
    // mode: "history", // 需要服务端支持
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });
const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js